import React from "react";
import ReactDOM from "react-dom";
import PropTypes from "prop-types";
import { connect } from 'react-redux'

import withStyles from "@material-ui/core/styles/withStyles";
import InputAdornment from "@material-ui/core/InputAdornment";
import Icon from "@material-ui/core/Icon";

import Face from "@material-ui/icons/Face";

import Header from "../../components/Header/Header.jsx";
import HeaderLinks from "../../components/Header/HeaderLinks.jsx";
import Footer from "../../components/Footer/Footer.jsx";
import GridContainer from "../../components/Grid/GridContainer.jsx";
import GridItem from "../../components/Grid/GridItem.jsx";
import Button from "../../components/CustomButtons/Button.jsx";
import Card from "../../components/Card/Card.jsx";
import CardBody from "../../components/Card/CardBody.jsx";
import CardHeader from "../../components/Card/CardHeader.jsx";
import CustomInput from "../../components/CustomInput/CustomInput.jsx";

import { login } from "../../actions/user"

import loginPageStyle from "../../assets/jss/material-kit-pro-react/views/loginPageStyle.jsx";
import image from "../../assets/img/world.jpg";


class LoginPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = { username:'', password:'', cardAnimation:'cardHidden', search: props.location.search }
        this.handelLogin = this.handelLogin.bind(this)
        this.handelUsernameChange = this.handelUsernameChange.bind(this)
        this.handelPasswordChange = this.handelPasswordChange.bind(this)
        this.handleKeyPress = this.handleKeyPress.bind(this)
    }
    componentDidMount() {
        window.scrollTo(0, 0);
        document.body.scrollTop = 0;
        let f = ()=>{ this.setState({cardAnimation:''}) };
        f.bind(this);
        this.timeOutFunction = setTimeout(f,700)
    }
    componentWillUnmount() {
        clearTimeout(this.timeOutFunction)
        this.timeOutFunction = null
    }
    handleKeyPress(e){
        if (e.key === 'Enter') {
            ReactDOM.findDOMNode(this.loginButton).focus()
            this.loginButton.props.onClick(e)
        }
    }
    handelLogin() {
        this.props.dispatch(login(this.state.username, this.state.password, this.state.search))
    }
    handelUsernameChange(e){
        this.setState({username:e.target.value})
    }
    handelPasswordChange(e){
        this.setState({password:e.target.value})
    }
    render() {
        const { classes, data } = this.props,
            {authentication} = data,
            invalid = authentication.status === 'invalid',
            success = authentication.status === 'valid';
        let status = {};
        if (invalid) {
            status['error'] = true;
            status['labelText']= "Incorrect input";
        }
        else if(success)
            status['success'] = true;
        return (
            <div>
                <Header
                    absolute
                    color="transparent"
                    brand="Material Kit PRO React"
                    links={<HeaderLinks dropdownHoverColor="info" />}
                />
                <div
                    className={classes.pageHeader}
                    style={{
                        backgroundImage: `url(${image})`,
                        backgroundSize: "cover",
                        backgroundPosition: "top center"
                    }}
                >
                    <div className={`${classes.container} candid-login-container`}>
                        <GridContainer justify="center">
                            <GridItem xs={12} sm={12} md={4}>
                                <Card className={classes[this.state.cardAnimation] + ' ' + classes.cardLogin}>
                                    <form className={classes.form}>
                                        <CardHeader color="primary" signup className={classes.cardHeader}>
                                            <h4 className={classes.cardTitle}>Login</h4>
                                            <div className={classes.socialLine}></div>
                                        </CardHeader>
                                        <p className={`${classes.description} ${classes.textCenter}`}></p>
                                        <CardBody signup>
                                            <CustomInput id="first" formControlProps={{fullWidth: true}} {...status}
                                                inputProps={{
                                                    onChange:this.handelUsernameChange,
                                                    onKeyPress: this.handleKeyPress,
                                                    placeholder: "Login Name",
                                                    type: "text",
                                                    startAdornment: (
                                                        <InputAdornment position="start">
                                                            <Face className={classes.inputIconsColor} />
                                                        </InputAdornment>
                                                    )
                                                }}
                                            />
                                            <CustomInput id="pass" formControlProps={{fullWidth: true}} {...status}
                                                inputProps={{
                                                    onChange:this.handelPasswordChange,
                                                    onKeyPress: this.handleKeyPress,
                                                    placeholder: "Password",
                                                    type: "password",
                                                    startAdornment: (
                                                        <InputAdornment position="start">
                                                            <Icon className={classes.inputIconsColor}>
                                                                lock_utline
                                                            </Icon>
                                                        </InputAdornment>
                                                    )
                                                }}
                                            />
                                        </CardBody>
                                        <div className={classes.textCenter}>
                                            <Button simple color="primary" size="lg" onClick={this.handelLogin} ref={(button) => { this.loginButton = button; }}>
                                                Get started
                                            </Button>
                                        </div>
                                    </form>
                                </Card>
                            </GridItem>
                        </GridContainer>
                    </div>
                    <Footer className={classes.footer}
                        content={<div>
                            <div >
                                Copyright &copy; {1900 + new Date().getYear()}
                                <a href="https://candid.org"> Candid</a> All Rights Reserved. Privacy Policy Copyright
                            </div>
                            <div className={classes.right}>
                            </div>
                        </div>
                        }
                    />
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => { 
    return {
        data: state
    }
};

LoginPage.propTypes = {
    classes: PropTypes.object,
    location: PropTypes.object,
    authentication: PropTypes.object,
    data: PropTypes.object,
    dispatch: PropTypes.func
}

const styledComponent = withStyles(loginPageStyle)(LoginPage);
export default connect(mapStateToProps)(styledComponent);



// WEBPACK FOOTER //
// ./src/views/LoginPage/LoginPage.jsx